import { axiosInstance, callPost, callPut } from "./index";
import { LARAVEL_APP_HOST } from "../constants";
import { User } from "models/User";

export class UserAPI {
  static updatePhonePath = LARAVEL_APP_HOST + "/api/v2/users/me/phone";
  static createOtherPath = LARAVEL_APP_HOST + "/api/v2/users/other";
  // static updatePath = LARAVEL_APP_HOST + "/api/v1/user"; // Updates are currently done to user profile only

  static async updatePhone(phone: string | null): Promise<boolean> {
    try {
      callPost(this.updatePhonePath, { phone })
      return true
    } catch (e) {
      console.error((e as any)?.message)
    }

    return false
  }

  static async completeOnboarding(skipEvent = false): Promise<void> {
    try {
      let body: any = undefined
      if (skipEvent) {
        body = {
          skip_event: true,
        }
      }
      await callPut(`${User.path}/me/complete-on-boarding`, body);
    } catch (e) {
      console.error("failed to complete onboarding, " + (e as any)?.message)
    }
  }

  static async completeProbateQuiz(redirectTo: string, jurisdiction: string, packetName: string, numForms: number,): Promise<void> {
    try {
      await callPut(`${User.path}/me/complete-probate-quiz`, {
        login_link: redirectTo,
        jurisdiction,
        packet_name: packetName,
        num_forms: numForms,
      });
    } catch (e) {
      console.error("failed to complete probate quiz, " + (e as any)?.message)
    }
  }

  static async createOtherUser(user: User): Promise<User | undefined> {
    try {
      const response = await callPost(this.createOtherPath, user.toJson());
      return User.fromJSON(response?.data)
    } catch (e) {
      console.error((e as any)?.message)
    }
  }

}
